// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_2HBgP","visuallyhidden":"_2HYUD","hide-text":"_9jk-Z","center":"_2jq9Q","noprint":"m0IBx","root":"_2NumO","image":"_1-isB","alternateImagePosition":"_2ILBU","content":"P7TUR","label":"_1YnST"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-teaser-small/styles/sports.scss
 ** module id = 346
 ** module chunks = 2
 **/